import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../../components/common/PageHeader";
import { getStageById } from "../api/stageService";
import { toast } from "react-toastify";
import { Stage } from "../types/stage.types";
import "../styles/StageList.css";

const ViewStage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [stage, setStage] = useState<Stage | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    fetchStage(Number(id));
  }, [id]);

  const fetchStage = async (stageId: number) => {
    try {
      const res = await getStageById(stageId);
      setStage(res.data);
    } catch (error) {
      console.error("Failed to load stage", error);
      toast.error("Failed to load stage details");
      navigate("/stage");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="container mt-4">Loading...</div>;
  }

  if (!stage) return null;

  return (
    <>
      <PageHeader
        title="View Stage"
        breadcrumbs={[
          { label: "Home", path: "/dashboard" },
          { label: "Masters", path: "/stage" },
          { label: "View Stage" },
        ]}
      />

      <div className="container mt-4">
        <div className="card p-4">

          <h6 className="fw-bold mb-3">Basic Information</h6>

          <div className="row mb-3">
            <div className="col-md-4 text-muted">Stage Name</div>
            <div className="col-md-8 fw-semibold">
              {stage.stage_name || "-"}
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-4 text-muted">Status</div>
            <div className="col-md-8">
              <span
                className={`status-badge ${
                  stage.is_active ? "active" : "inactive"
                }`}
              >
                {stage.is_active ? "Active" : "Inactive"}
              </span>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-4 text-muted">Description</div>
            <div className="col-md-8 fw-semibold">
              {stage.description || "-"}
            </div>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <button
              className="btn btn-secondary"
              onClick={() => navigate("/stage")}
            >
              Back
            </button>
          </div>

        </div>
      </div>
    </>
  );
};

export default ViewStage;
